module.exports = __webpack_public_path__ + "static/media/myriadlogo.3c63572a.jpg";